<template>
  <div class="mobile-container">
    <page-header>{{'大会日程' | dealLanguage('Conference Agenda')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="main-content">
      <div class="first-froum" v-if="main_froum.activityId">
        <div class="froum-title">
          <span>{{main_froum['activityName'] | dealLanguage(main_froum['enActivityName'])}}</span>
        </div>
      </div>
      <div
        class="froum-module"
        v-for="(item, index) in froum_modules"
        :key="index"
      >
        <div class="froum-module-title">
          <span>{{`模块${index + 1}：` | dealLanguage(`Module ${index + 1}:`)}} {{ item.title | dealLanguage(item.enTitle) }}</span>
        </div>
        <div class="froum-list">
          <div
            class="froum-li"
            v-for="(fItem, fIndex) in froum_list.filter((a) => item.themeIds.includes(a.activityId - 0))"
            :key="fIndex"
          >
            <div class="froum-title">{{ fItem.activityName | dealLanguage(fItem.enActivityName)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('大会日程', 'Conference Agenda'),
    }
  },
  inject: ['globalInsertRecords', 'wxShare'],
  data () {
    return {
      main_froum: {},
      froum_list: [],
      loading: false,
      froum_modules: [
        {
          title: '基因治疗与基因编辑',
          enTitle: 'Gene Therapy and Gene Editing',
          themeIds: [1033, 1034, 1035, 1036],
        },
        {
          title: '免疫细胞治疗',
          enTitle: 'Immune Cell Therapy',
          themeIds: [1037, 1038, 1039],
        },
        {
          title: '干细胞治疗与再生医学',
          enTitle: 'Stem Cell Therapy and Regeneration Medicine',
          themeIds: [1040, 1041, 1042],
        },
        {
          title: '小核酸药物',
          enTitle: 'Small RNA Drug',
          themeIds: [1043, 1044],
        },
        {
          title: '全球先进疗法的探索',
          enTitle: 'Global Advanced Therapy Exploration',
          themeIds: [1045, 1046],
        },
        {
          title: '818 与 828 新政之下的GLP、GCP、GMP',
          enTitle: 'GLP, GCP, G GMP',
          themeIds: [1047, 1129, 1133, 1134, 1135],
        },
        {
          title: 'AI+药物研发',
          enTitle: 'AI+Drug Development',
          themeIds: [1136, 1137, 1138, 1139, 1140],
        },
        {
          title: '新型递送',
          enTitle: 'Nov Delivery',
          themeIds: [1141],
        },
        {
          title: 'MED TALK',
          enTitle: 'MED TALK',
          themeIds: [1142],
        },
        {
          title: '投融资与BD',
          enTitle: 'Investment and Development',
          themeIds: [1143],
        },
        {
          title: '临床应用与突破',
          enTitle: 'Clinical Application and Breakthrough',
          themeIds: [1144, 1145, 1150, 1147],
        },
        {
          title: '全球CGT破局',
          enTitle: 'Global CGT Breakthrough',
          themeIds: [1148, 1149],
        },
      ],
    }
  },

  components: {
    PageHeader
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
    })
  },

  created() {
    this.getAgendaList()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('大会日程-CSGCT', 'Conference Agenda-CSGCT'),
      linkurl: this.vbef_path + '/theme',
    })
  },

  methods: {
    async getAgendaList() {
      this.loading = true
      let res = await getAgendaList({
        actId: this.activityId,
        assortName: '',
        dateName: '',
      })
      this.loading = false
      if (res.code == 0 && res.data.activities.length > 0) {
        this.$set(this.$data, 'main_froum', res.data.activities[0])
        this.$set(this.$data, 'froum_list', res.data.activities)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  position relative
  .main-content
    padding .4rem
    .first-froum
      background-image url('~pic/theme-bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      height 1.8rem
      display flex
      align-items center
      cursor pointer
      .froum-title
        width 100%
        height .8rem
        background linear-gradient(90deg, rgba(255, 167, 98, 0.6) 0%, #FF7000 53%, rgba(255, 167, 98, 0.6) 100%)
        padding 0 .4rem
        font-weight 400
        font-size .24rem
        color #FFFFFF
        line-height 1.5
        display flex
        align-items center
        justify-content center
  .froum-module-title
    font-weight 400
    font-size .28rem
    color #C7000C
    line-height .4rem
    padding .16rem .2rem
    display flex
    align-items center
    justify-content center
    background #FFF3F3
    border-left 1px solid #ED6D01
    border-right 1px solid #ED6D01
  .froum-list
    display flex
    border 1px solid #ED6D01
    .froum-li
      flex 1
      border-right 1px solid #ED6D01
      padding .2rem
      display flex
      align-items center
      cursor pointer
      transition: all .3s ease-in-out
      &:last-child
        border-right 0
      &:hover
        background-color: #FFE8D9
      .froum-title
        width 100%
        font-weight 400
        font-size .24rem
        color #C7000C
        line-height .36rem
        text-align: center
</style>
